export type EtcDataType = "image" | "docs" | "video" | "gis" | "line";

export type ThreeDModelType = "bim" | "las";

/** LayerData 탭의 UI/S3 경로 타입 — S3 경로·로케일 키는 "line" 을 쓴다. */
export type LayerDataUiType = "gis" | "line" | "bim" | "las";

/** layer-data API 계약 타입 — 백엔드는 "linear" 를 쓴다. */
export type LayerDataApiType = "gis" | "linear" | "bim" | "las";

/** UI 타입 ↔ API 타입 매핑의 단일 출처 — "line"/"linear" 변환은 반드시 여기를 경유한다. */
export const LAYER_DATA_API_TYPE: Record<LayerDataUiType, LayerDataApiType> = {
  gis: "gis",
  line: "linear",
  bim: "bim",
  las: "las",
};

export type LayerDataProcessingStatus =
  | "before"
  | "on_processing"
  | "failed"
  | "completed";

export interface LayerDataItem {
  /** 확장자를 제외한 S3 파일명 stem — rename API 계약과 동일한 불변 식별자 */
  origin_file_name: string;
  /** 표시명 — DB NULL 이면 백엔드가 origin_file_name 으로 채워 항상 non-null */
  display_name: string;
  /** bytes — 백엔드가 크기 미산출 항목에 null 을 보낸다 (표시는 `-`, 집계는 0 취급) */
  file_size: number | null;
  status: string;
  ext: string;
}

export interface LayerDataGroups {
  gis: LayerDataItem[];
  linear: LayerDataItem[];
  bim: LayerDataItem[];
  las: LayerDataItem[];
}

/** 구 API 표기(processing/complete)가 섞여 와도 StatusChip 상태로 흡수한다. */
export function normalizeLayerDataStatus(
  status: string
): LayerDataProcessingStatus {
  if (status === "processing" || status === "on_processing")
    return "on_processing";
  if (status === "complete" || status === "completed") return "completed";
  if (status === "failed") return "failed";
  return "before";
}

/** ext 의 점(.) 포함 여부와 무관하게 `<stem>.<ext>` 파일명을 만든다. */
export function joinExt(stem: string, ext: string): string {
  if (!ext) return stem;
  return ext.startsWith(".") ? `${stem}${ext}` : `${stem}.${ext}`;
}

export type StratumLayerType =
  | "stratum"
  | "design_height"
  | "design_profile"
  | "drawing";

/**
 * 드론 이미지 **업로드 원본** 하나의 크기 — 업로드가 올린 `pipeline/original_drone_images/{회차}/` 의 객체다.
 * 썸네일·압축본 같은 서버 파생물의 크기가 아니다(spec: project-drone-image-management).
 */
export interface OriginalDroneImageSize {
  /** 원본 객체 키의 파일명 — 업로드가 NFD 로 접어 올린 원본 파일명 그대로다(정규화 접기는 짝짓는 쪽이 한다) */
  name: string;
  /** byte — 목록 조회가 크기를 싣지 않았으면 `null`(모름) */
  size: number | null;
}

